import { createContext, useContext, useEffect, useRef } from "react";

// Lets a page inside Payroll Settings show its breadcrumb at the very top
// of the screen (in PayrollSettingsHeader, above "⚙ Payroll Settings")
// instead of above its own title. Outside Payroll Settings there is no
// provider, and pages keep rendering their breadcrumb themselves.
export const SettingsBreadcrumbContext = createContext(null);

const labelOf = (item) => (typeof item === "string" ? item : item?.label || "");

// Hands `trail` to the Payroll Settings header. Returns true when it did,
// so the caller skips its own breadcrumb. The header is only updated when
// the labels change; clicks always run the page's latest handler.
export const useHoistedBreadcrumb = (trail) => {
  const setTrail = useContext(SettingsBreadcrumbContext);
  const latest = useRef(trail);
  latest.current = trail;
  const key = (trail || []).map(labelOf).join(" › ");

  useEffect(() => {
    if (!setTrail || !key) return undefined;
    setTrail(
      (latest.current || []).map((item, index) =>
        typeof item === "string" || !item?.onClick
          ? item
          : { label: item.label, onClick: () => latest.current?.[index]?.onClick?.() },
      ),
    );
    return () => setTrail(null);
  }, [setTrail, key]);

  return Boolean(setTrail && key);
};
